import React from 'react'
import Link from 'gatsby-link'
import ProjectCards from '../components/ProjectCards';
import BackNav from '../components/BackNav';
import HeaderRainbow from '../components/HeaderRainbow';
import Unicorn from '../components/Unicorn';

import sliceTop from '../images/slice-top.svg'
import sliceBottom from '../images/slice-bottom.svg'

// Work Thumbnails
// import workGustoDocuments from '../images/work-gusto-documents.jpg'
import critiques from '../images/critiques.png'
import writingProcess from '../images/writing-process.jpg'
import writingBiz from '../images/writing-business-software.jpg'

// Art images
import artSVG from '../images/art-txt-3.svg';
import dybSet from '../images/dyb-poster-set.jpg'
import dybDetail from '../images/art-dyb-1.png'
import art2 from '../images/everybody.jpg'
import art2Detail from '../images/art-dyb-1.png'

const IndexPage = () =>
  <div>
    <HeaderRainbow />
    <Unicorn />
    <div className="half-page main">
      <h1 className='huge-text'>🦄 Hi, I'm Will</h1>
      <div className="indent half-page">
        <p><strong>I create experiences that people <span className="love">love</span>.</strong></p>
        <p>Most recently I worked with several teams at <a target="_blank" href="https://gusto.com">Gusto</a>, designing new financial products for employees.</p>
        <p>Previously I worked with a talented team to create a DJ app that people love
        called <a target="_blank" href="https://www.facebook.com/crossfaderapp/">Crossfader</a>.</p>
        <p>I designed a little app <a target="_blank" href="http://breatheapp.co/">Breathe</a> to help people practice mindfulness, which <i>(funny story!)</i> is <a href="https://observer.com/2016/12/apple-watch-rips-off-silicon-valley-developers-iphone-breathe-app/">no longer around.</a></p>
        <p>Nights and weekends I make make dance music with my record label <a target="_blank" href="http://pizzaandtechno.com">Pizza &amp; Techno</a>.</p>

      </div>
    </div>
    <div className="block-slice">
      <img src={sliceTop} className="top-slice-svg" />
    </div>
    <div className="rainbow block">
      <div id="work" className="main white-text">
        <h1 className='huge-text'>Selected work:</h1>
        <ProjectCards />
        <a target="_blank" href="https://dribbble.com/willdjthrill"  className="more-link">see more pixels on dribbble</a>
      </div>

      <div className="main white-text margin-top-50 padding-bottom-50">
        <h1 className='margin-none huge-text'> Writing </h1>
        <div className="card-holder">
        <a href='https://medium.com/gusto-design/getting-the-most-out-of-design-critiques-dea20f7425d'>
            <div className="card first-card">
              <img className='card-img' src={critiques} />
              <p className='card-text'>Getting the most out of design critiques</p>
            </div>
          </a>
          <a href='https://medium.com/@willdjthrill/waiting-for-a-sign-to-start-building-your-design-teams-component-library-c43f4352c764'>
            <div className="card second-card">
              <img className='card-img' src='https://cdn-images-1.medium.com/max/2000/1*3mOZuMo4ap1NfW3ugn93ng.png' />
              <p className='card-text'>The beginnings of our design system</p>
            </div>
          </a>
          <a href='https://medium.com/@willdjthrill/designing-delightful-business-software-51612a9f2f'>
            <div className="card third-card">
              <img className='card-img' src={writingBiz} />
              <p className='card-text'>Designing Delightful Business Software</p>
            </div>
          </a>
          <a href='https://medium.freecodecamp.org/the-design-process-a-pyramid-c77135c177d4'>
            <div className="card fourth-card">
              <img className='card-img' src={writingProcess} />
              <p className='card-text'> The Design Process: A Pyramid</p>
            </div>
          </a>
        </div>
        <a target="_blank" href="https://medium.com/@willdjthrill" className="more-link">follow on Medium</a>
      </div>
    </div>
    <div className="block-slice">
      <img src={sliceBottom} className="bottom-slice-svg" />
    </div>

    <div className="half-page main unicorn-text">
      <h1 className='huge-text'><i>Unicorns<br />exist.</i><br /></h1>
      </div>

    <div className="block-slice unicorn-text">
      <img src={sliceTop} className="top-slice-svg" />
    </div>
    <div className="rainbow block padding-bottom-50">
      <div className="main white-text">
        <h1 className="">Elsewhere online:</h1>
        <div className="footer-links-list bigger">
          <a target="_blank" href="https://twitter.com/willdjthrill" >Twitter</a>
          <a target="_blank" href="https://dribbble.com/willdjthrill" >Dribbble</a>
          <a target="_blank" href="https://medium.com/@willdjthrill" >Medium</a>
          <a target="_blank" href="https://instagram.com/wow_willnewton" >Instagram</a>
          <a target="_blank" href="https://soundcloud.com/djwillaa" >Soundcloud</a>
          <a target="_blank" href="https://mixcloud.com/willaa" >Mixcloud</a>
        </div>
      </div>


      <div className="footer-subtext white-text text-center">
        <p>© William Newton 2020   |   Handwritten by myself using <a target="_blank" className='white-text' href="https://www.gatsbyjs.org/">GatsbyJS</a></p>
      </div>
    </div>

  </div>

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js